import React, { useEffect, useState, useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'
import MuiSnackbar from '@material-ui/core/Snackbar'
import useStyles from 'ui/components/snackbar/styles'
import { SnackbarContent } from 'notistack'

import { useSelector, useDispatch } from 'react-redux'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconUndo } from 'assets/icons/undo.svg'
import { ReactComponent as IconCorrect } from 'assets/icons/correct.svg'

import useTranslation from 'hooks/useTranslations'

import { getSnackbarById } from 'services/snackbar/selectors'
import { closeSnackbar } from 'services/snackbar/actions'

const Snackbar = React.forwardRef((props, ref) => {
  const { message, id } = props
  const { actionToDo } = useSelector(getSnackbarById(id))
  const dispatch = useDispatch()
  const [progress, setProgress] = useState(0)

  const t = useTranslation()

  const classes = useStyles()

  useEffect(() => {
    function tick() {
      setProgress(oldProgress => (oldProgress >= 100 ? 100 : oldProgress + 1))
    }

    const timer = setInterval(tick, 50)
    return () => {
      clearInterval(timer)
    }
  }, [])

  const finished = useMemo(() => progress === 100, [progress])

  const handleClose = useCallback(() => {
    dispatch(closeSnackbar(id))
  }, [dispatch, id])

  return (
    <SnackbarContent ref={ref} className={classes.root}>
      <MuiSnackbar
        className={classes.root}
        ContentProps={{ className: classes.content }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={true}
        message={
          <>
            {finished ? (
              <SvgIcon component={IconCorrect} />
            ) : actionToDo ? (
              <CircularProgress
                variant="determinate"
                value={progress}
                size={20}
              />
            ) : (
              <SvgIcon component={IconCorrect} />
            )}
            <Typography variant="body1">{t(message)}</Typography>
          </>
        }
        action={
          actionToDo && !finished ? (
            <>
              <Button
                color="primary"
                startIcon={<SvgIcon component={IconUndo} />}
                onClick={handleClose}
              >
                {t('action:undo')}
              </Button>
            </>
          ) : null
        }
      />
    </SnackbarContent>
  )
})

Snackbar.propTypes = {
  open: PropTypes.bool,
  message: PropTypes.string,
  action: PropTypes.node,
}

export default Snackbar
